import { Tab, Tabs, styledTabsProps } from "components/Tabs"

import { RateCardSupplierProduct as Channel } from "models/ratecard"
import { CreateChannelModal } from "./CreateChannelModal"
import DeleteIcon from "@material-ui/icons/Cancel"
import IconButton from "ui/buttons/IconButton"
import { css } from "@emotion/css"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"
import { useToggle } from "hooks/useToggle"

type ChannelsProps = {
  rateCardId: string
  supplierId: string
  mediaTypeId: string
  //
  channels: Channel[]
  //
  active: string
  onActiveChange: (id: string) => void
  deletable?: boolean
  onDelete: (channelId: string, location?: string | undefined) => void
}

export function Channels(props: ChannelsProps) {
  const { t } = useI18n()
  const {
    rateCardId,
    supplierId,
    mediaTypeId,
    channels,
    active,
    onActiveChange,
    deletable = false,
    onDelete,
  } = props

  const { hasAuthority } = useAuthenticated()
  const createChannelModal = useToggle()

  const usedChannels = channels.map((x) => x.id)
  const allowed = hasAuthority([
    "AUTH_CREATE_RATE_CARD",
    "AUTH_EDIT_RATE_CARD",
    "AUTH_DELETE_RATE_CARD",
  ])

  return (
    <Tabs value={active} {...styledTabsProps} onTabChange={onActiveChange}>
      {channels.map((channel) => (
        <Tab
          key={channel?.id}
          value={channel?.id}
          label={
            <span className={styles.tabLabel}>
              <span className={styles.label}>{t(channel?.name)}</span>
              {deletable && allowed && (
                <DeleteIcon
                  onClick={() => onDelete(channel?.id)}
                  className={styles.icon}
                />
              )}
            </span>
          }
          selected={channel.id === active}
        />
      ))}

      {allowed && (
        <div>
          <IconButton
            onClick={createChannelModal.onOpen}
            className={styles.addButton}
          >
            +
          </IconButton>
        </div>
      )}

      <CreateChannelModal
        key={`${createChannelModal.open}`} // remount
        open={createChannelModal.open}
        onClose={createChannelModal.onClose}
        rateCardId={rateCardId}
        supplierId={supplierId}
        mediaTypeId={mediaTypeId}
        used={usedChannels}
      />
    </Tabs>
  )
}

const styles = {
  tabLabel: css`
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  `,
  label: css`
    min-width: 80px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  `,
  icon: css`
    object-fit: contain;
    color: var(--disabled-grey);
    width: 14px;
    margin: 0 4px;
  `,
  addButton: css`
    width: 30px;
    height: 30px;
    font-size: 16px;
  `,
}
